import clsx from "clsx";
import React, { ReactElement } from "react";
import { Icon, IconName } from "../Icon/Icon";
import styles from "./BarCheckbox.module.scss";

export interface BarCheckboxProps {
  disabled?: boolean;
  checked?: boolean;
  label: string;
  description?: ReactElement | string;
  counterLabel?: ReactElement | string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  backgroundColor?: "gray" | "white";
  iconName?: IconName;
}

export const BarCheckbox: React.FC<
  React.PropsWithChildren<BarCheckboxProps>
> = ({
  disabled,
  checked,
  label,
  counterLabel,
  onChange,
  children,
  description,
  backgroundColor = "gray",
  iconName
}) => {
  return (
    <div
      className={clsx(styles.container, {
        [styles.backgroundColorWhite]: backgroundColor == "white"
      })}
    >
      <label className={styles.labelContainer}>
        <input
          className={styles.input}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
        <div className={styles.content}>
          {iconName && (
            <Icon
              name={iconName}
              size="1.5x"
              padding={false}
              className={styles.mainIcon}
            />
          )}
          <div className={styles.label}>
            <div className={styles.labelText}>{label}</div>
            <div className={styles.description}>{description}</div>
          </div>
          {counterLabel && <div className={styles.counter}>{counterLabel}</div>}
          {children}
          <Icon
            name="check"
            size="1.5x"
            padding={false}
            className={styles.checkIcon}
          />
        </div>
      </label>
    </div>
  );
};
